import { __decorate, __metadata } from "tslib";
import { inject, useView, PLATFORM, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
/**
 * @selector button[mdc-button]
 * @selector a[mdc-button]
 * @selector mdc-button
 */
var MdcButton = /** @class */ (function () {
    function MdcButton(root) {
        this.root = root;
    }
    MdcButton.prototype.disabledChanged = function () {
        if (this.disabled) {
            this.root.setAttribute('disabled', '');
        }
        else {
            this.root.removeAttribute('disabled');
        }
    };
    MdcButton.prototype.hrefChanged = function () {
        if (this.href) {
            this.root.setAttribute('href', this.href);
        }
        else {
            this.root.removeAttribute('href');
        }
    };
    MdcButton.prototype.attached = function () {
        var icons = this.root.querySelectorAll('mdc-icon');
        Array.from(icons).forEach(function (x) { return x.classList.add('mdc-button__icon'); });
    };
    __decorate([
        bindable.booleanAttr,
        __metadata("design:type", Boolean)
    ], MdcButton.prototype, "touch", void 0);
    __decorate([
        bindable.booleanAttr,
        __metadata("design:type", Boolean)
    ], MdcButton.prototype, "raised", void 0);
    __decorate([
        bindable.booleanAttr,
        __metadata("design:type", Boolean)
    ], MdcButton.prototype, "unelevated", void 0);
    __decorate([
        bindable.booleanAttr,
        __metadata("design:type", Boolean)
    ], MdcButton.prototype, "outlined", void 0);
    __decorate([
        bindable.none,
        __metadata("design:type", String)
    ], MdcButton.prototype, "label", void 0);
    __decorate([
        bindable.booleanAttr,
        __metadata("design:type", Boolean)
    ], MdcButton.prototype, "disabled", void 0);
    __decorate([
        bindable.none,
        __metadata("design:type", String)
    ], MdcButton.prototype, "href", void 0);
    MdcButton = __decorate([
        inject(Element),
        useView(PLATFORM.moduleName('./mdc-button.html')),
        customElement('mdc-button'),
        __metadata("design:paramtypes", [HTMLElement])
    ], MdcButton);
    return MdcButton;
}());
export { MdcButton };
//# sourceMappingURL=mdc-button.js.map